import { render, staticRenderFns } from "./documentAssociationConfig.vue?vue&type=template&id=f3e16646&scoped=true"
import script from "./documentAssociationConfig.vue?vue&type=script&lang=js"
export * from "./documentAssociationConfig.vue?vue&type=script&lang=js"
import style0 from "./documentAssociationConfig.vue?vue&type=style&index=0&id=f3e16646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e16646",
  null
  
)

export default component.exports